/**
 * 富文本组件核心接口，从dc组件copy过来。
 * packages-old/docs-component-comment-editable/src/old-comment-editable/core/comment_editable_core.tsx
 */
export interface ICommentEditable {
    container: HTMLDivElement;
    /**
     * 获取输入框内容
     * @param index 内容的下标
     * @param length 内容的长度
     */
    getContents: (index?: number, length?: number) => { ops: ICommentEditableOps[] };
    /**
     * 设置输入框内容
     * @param delta 插入的内容，Delta格式
     */
    setContents: (delta: ICommentEditableOps[]) => void;
    /**
     * 在当前选区插入一段文本
     * @param text 插入的内容
     */
    insertContentText: (text: string, index: number) => void;
    /**
     * 获取选区信息
     * @param focus 是否需要获取焦点
     */
    getSelection: (focus?: boolean) => ITextAreaSelection;
    /**
     * 设置选取信息
     * @param index 下标的位置
     * @param length 内容的长度
     */
    setSelection: (index: number, length: number) => void;
    /**
     * 插入一个内联块元素(span）
     * @param embedConfig 插入内联元素配置
     * @param source 触发的对象
     */
    insertEmbed: (args: EmbedConfig) => void;
    /**
     * 删除输入框内容
     * @param index 需要删除内容的下标
     * @param length 删除的长度
     */
    deleteText: (fromIndex: number, length: number) => void;
    /**
     * 插入一个文本
     * @param index 插入的位置
     * @param text 插入的内容
     */
    insertText: (fromIndex: number, text: string) => void;
    /**
     * 获取输入框内容长度
     */
    getLength(): number;
}

export interface ITextAreaSelection {
    index: number;
    length: number;
}

export interface ICommentEditableOps {
    attributes?: {
        id: string;
        'data-avatar'?: string;
    };
    data?: IMentionUserInfo;
    insert?:
        | string
        | {
            mention: string;
        };
    text?: string;
}

export interface ITextContent {
    text: string;
    data?: IMentionUserInfo;
}

export interface IMentionUserInfo {
    mentionId: string;
    avatar: string;
    globalPadId: string;
    // 这里目前只可能是0
    mentionType: 0;
    mentionUserID: string;
}

export interface EmbedConfig {
    index: number;
    key: string;
    value: string;
    formats: IMentionFormats;
}

interface IMentionFormats {
    id: string;
    'data-avatar'?: string;
}

export enum InputCommitStatus {
    // 不可以提交的状态
    // 比如初始状态，此时提交也没有任何意义
    INVALID = 'INVALID',

    // 正常的文本输入，可以提交
    NORMAL_INPUT_DONE = 'NORMAL_INPUT_DONE',

    // 输入中，暂不能提交
    // 情况有几种：
    // 1. 还在输入法的composing状态
    // 2. 进入插件，输入尚未完成
    PENDING = 'PENDING',

    // 正在提交中
    COMMITING = 'COMMITING',

    // 委派输入结束，可以提交
    // 一般在插件输入结束后切换到此状态
    DELEGATE_INPUT_DONE = 'DELEGATE_INPUT_DONE',
}
